var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusDottedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "New_color",
    "data-name": "New color",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_156",
    "data-name": "Ellipse 156",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    strokeDasharray: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_164",
    "data-name": "Union 164",
    d: "M2.083,4.584V2.918H.416a.416.416,0,0,1,0-.832H2.083V.419a.417.417,0,1,1,.835,0V2.086H4.584a.416.416,0,0,1,0,.832H2.918V4.584a.417.417,0,0,1-.835,0Z",
    transform: "translate(4 4.118)",
    fill: "rgba(112,112,112,0.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusDottedIcon);
export default __webpack_public_path__ + "static/media/plus-dotted-icon.866d148cb97a19549d8414577fa5d4ce.svg";
export { ForwardRef as ReactComponent };